<template>

  <!-- <button type="button" class="btn btn-secondary" data-toggle="tooltip" data-html="true" :title="description">i</button> -->
  <!-- <span type="button" class="glyphicon glyphicon-info-sign" data-toggle="tooltip" data-html="true" :title="description">i</span> -->
  <!-- <button type="button" class="btn btn-secondary" data-toggle="tooltip" data-html="true" :title="description">i</button> -->

  <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" data-html="true" :title="description"></span>


</template>
<script>
  export default {
    name: 'tooltip',
    props: {description:''}
  }
</script>